import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import {Table, TableCell, TableRow, TableHead} from 'react-toolbox/lib/table'
import { IconButton } from 'react-toolbox'
import { getTranslationKey } from 'containers/Greenlight/utils'
import { EXCLUDED_SPECS } from 'containers/Greenlight/TestReport/constants'
import T from 'i18n-react'
import * as R from 'ramda'

const tableHeadContent = {
    attributes: (<TableCell key={0}>&nbsp;</TableCell>),
    fulcrum: (<TableCell key={1}>&nbsp;</TableCell>),
    system: (<TableCell key={2}>&nbsp;</TableCell>),
    results: (<TableCell key={3}>&nbsp;</TableCell>),
}

const getTableHead = (tableHeadContent) =>  (
    <TableHead>
        {R.map((key) => tableHeadContent[key], R.keys(tableHeadContent))}
    </TableHead>
)

const getResults = (result) => (
    (result ? <IconButton style={{color: 'rgb(99, 156, 0)'}} icon='check'/> : <IconButton style={{color: 'orange'}} className='fail' icon='priority_high' /> )
)

const getViewTableRows = (source, tableHeadContent) => {
    return (
        source.map((row, idx) => {
            let key = Object.keys(row)[0]
            let results
            if (!row[key].results) {
                results = row[key].fulcrum == row[key].system ? 'PASS' : 'FAIL'
            } else {
                results = row[key].results
            }
            return (
            <TableRow key={idx}>
                <React.Fragment>
                    <TableCell key={idx}>{T.translate(`testReport.dataTableValues.${key}.name`)}</TableCell>
                    <TableCell>{row[key].fulcrum ? row[key].fulcrum + T.translate(`testReport.dataTableValues.${key}.unit`) : '-'}</TableCell>
                    <TableCell>{row[key].system ? row[key].system + T.translate(`testReport.dataTableValues.${key}.unit`) : '-'}</TableCell>
                    <TableCell>{row[key].results ? getResults(results === 'PASS') : '-'}</TableCell>
                </React.Fragment>
            </TableRow>
            )
        })
    )
}

const prettify = (name, value) => {
    if(value != null && !isNaN(value)){
        return value + ' ' + T.translate(`testReport.dataTableValues.${name}.unit`)
    } else {
        return 'N/A'
    }
}

const renderRows = (data) => {

    let rowData = data.map((data) => {
        let group = JSON.parse(data.result)
        return Object.entries(group)
            .filter((entry) => {
                return typeof entry[1] !== 'string'
            })
            .map((row) => {
                let key = getTranslationKey(row[0])
                let val = row[1]
                let rowProps = {
                    fulcrum: (key, val[0]),
                    system: (key, val[1]),
                    results: val[2],
                }
                return { [key]: rowProps }
            })
    })

    return R.flatten(rowData)
}

const SystemResults = (props) => {
    return(
        <div className="tableContainer" style={{overflow: 'auto'}}>
            <Table theme={styles} selectable={false}>
                <TableHead>
                    <TableCell>Project Attributes</TableCell>
                    <TableCell>Fulcrum Spec Value</TableCell>
                    <TableCell>System Under Test Value</TableCell>
                    <TableCell>Match</TableCell>
                </TableHead>
                {getViewTableRows(renderRows(props.data), tableHeadContent)}
            </Table>
        </div>
    )
}

export default CSSModules(styles)(SystemResults)
